import { createDate, importAll, transformImages } from "utils";

import DailyProphet from "assets/replicas/harry-potter/hp-daily-prophets/_hp-daily-prophet-v2";
import ReplicaContent from "components/Replicas/ReplicaContent";
import { ReplicaVersionType } from "types";
import background from "./background.jpg";
import thumbnail from "./thumbnail.png";

let gallery = [];

try {
  gallery = importAll(
    (require as any).context("./gallery", false, /\.(png|jpe?g|svg)$/),
  );
} catch (e) {
  console.log(e);
}

/* VERSION DATA */
export const VERSION_DATA: ReplicaVersionType = {
  isWIP: false,
  page: undefined,
  dateCreated: createDate({ day: 30, month: 11, year: 2025 }),
  datePublished: createDate({ day: 25, month: 1, year: 2026 }),
  version: "2",
  isSeries: false,
  thumbnail,
  background,
};

/* VERSION PAGE */
const Page = () => {
  const galleryImages = transformImages(gallery);

  return (
    <ReplicaContent>
      <DailyProphet
        gallery={galleryImages}
        video="https://youtu.be/FSl_c1Ffl6E"
      />
    </ReplicaContent>
  );
};

export default {
  ...VERSION_DATA,
  page: <Page />,
} as ReplicaVersionType;
